// Display names for filter options (must match automationtool/config/event_config.json event_types)
export const USER_JOURNEY_EVENT_TYPES = [
  'Checkout success page visit',
  'Subscribe Now Clicked',
  'Pricing Page Visit',
  'Connect Instagram Clicked',
  'Analyse My Handles Clicked',
  'Download',
  'Share Video',
  'Session Attribution',
  'Visitor Country',
  'home page visit',
  'Features Page Visit',
  'Blog Page Visit',
  'Alternatives Page Visit',
  'Dashboard Page Visit',
  'Result Page Visit',
  'Terms Page Visit',
  'Policy Page Visit',
  'Refund Page Visit',
  'Logged In',
  'Sign In Clicked',
  'Login Failed',
  'Logged Out',
  'Terms Opened',
  'Policy Opened',
  'Refund Policy Opened',
  'Video selected to upload',
  'Video Url Added',
  'Clicked Add Phone Number : During Processing',
  'Provided Phone number : During Processing',
  'Clicked Add Phone Number : During Shorts Download',
  'Provided Phone number : During Shorts Download',
  'Video Too Long',
  'Video Too Large',
  'Pricing Region Shown',
  'Cancel Subscription (WhatsApp) Clicked',
  'Payment Abandonment Survey Visit',
  'Payment Abandonment Survey Closed',
  'Payment Abandonment Survey Continue Clicked',
  'Coupon Code Applied',
  'YouTube Started During Processing',
  'YouTube Paused During Processing',
  'Upload Another Video Clicked',
  'Clip Preview Played',
  'FAQ clicked',
  'Upload_Button',
  'Generate_Shorts_Button',
  'Signup_Button',
  'Back',
  'WhatsApp Support FAB',
  'WhatsApp Support Send',
  'WhatsApp Support Upgrade',
  'Streak Reminders Enabled',
  'Streak Reminders Denied',
  'Push Notification Opened',
  'Streak Reminders CTA',
  'Streak Remind Me Clicked',
  'Streak Overlay Shown',
  '1-Tap Publish Clicked',
  'Past Project Clicked',
  'Publish to Social Clicked',
  'Connect Account Clicked',
  '1-Tap Schedule Clicked',
  'Schedule a Clip Clicked',
  'Schedule Clip Dialog Submitted',
  '1-Tap Schedule Preferences Saved',
];

// Enum key → display name (for normalizing API event_types when backend returns enum keys)
export const EVENT_ENUM_TO_DISPLAY = {
  JOURNEY_SESSION_ATTRIBUTION: 'Session Attribution',
  VISITOR_COUNTRY: 'Visitor Country',
  HOME_PAGE_VISIT: 'home page visit',
  FEATURES_PAGE_VISIT: 'Features Page Visit',
  BLOG_PAGE_VISIT: 'Blog Page Visit',
  ALTERNATIVES_PAGE_VISIT: 'Alternatives Page Visit',
  DASHBOARD_PAGE_VISIT: 'Dashboard Page Visit',
  RESULT_PAGE_VISIT: 'Result Page Visit',
  PRICING_PAGE_VISIT: 'Pricing Page Visit',
  TERMS_PAGE_VISIT: 'Terms Page Visit',
  POLICY_PAGE_VISIT: 'Policy Page Visit',
  REFUND_PAGE_VISIT: 'Refund Page Visit',
  LOGGED_IN: 'Logged In',
  SIGN_IN_CLICKED: 'Sign In Clicked',
  LOGIN_FAILED: 'Login Failed',
  LOGGED_OUT: 'Logged Out',
  TERMS_OPENED: 'Terms Opened',
  POLICY_OPENED: 'Policy Opened',
  REFUND_POLICY_OPENED: 'Refund Policy Opened',
  VIDEO_SELECTED_TO_UPLOAD: 'Video selected to upload',
  VIDEO_URL_ADDED: 'Video Url Added',
  CLICKED_PHONE_NO_DURING_PROCESSING: 'Clicked Add Phone Number : During Processing',
  PROVIDED_PHONE_NO_DURING_PROCESSING: 'Provided Phone number : During Processing',
  CLICKED_PHONE_NO_DURING_DOWNLOAD: 'Clicked Add Phone Number : During Shorts Download',
  PROVIDED_PHONE_NO_DURING_DOWNLOAD: 'Provided Phone number : During Shorts Download',
  VIDEO_TOO_LONG: 'Video Too Long',
  VIDEO_TOO_LARGE: 'Video Too Large',
  PRICING_REGION_SHOWN: 'Pricing Region Shown',
  SUBSCRIBE_NOW_CLICKED: 'Subscribe Now Clicked',
  CHECKOUT_SUCCESS_PAGE_VISIT: 'Checkout success page visit',
  CANCEL_SUBSCRIPTION_WHATSAPP_CLICKED: 'Cancel Subscription (WhatsApp) Clicked',
  PAYMENT_ABANDONMENT_SURVEY_VISIT: 'Payment Abandonment Survey Visit',
  PAYMENT_ABANDONMENT_SURVEY_CLOSED: 'Payment Abandonment Survey Closed',
  PAYMENT_ABANDONMENT_SURVEY_CONTINUE_CLICKED: 'Payment Abandonment Survey Continue Clicked',
  COUPON_CODE_APPLIED: 'Coupon Code Applied',
  YOUTUBE_STARTED_DURING_PROCESSING: 'YouTube Started During Processing',
  YOUTUBE_PAUSED_DURING_PROCESSING: 'YouTube Paused During Processing',
  UPLOAD_ANOTHER_VIDEO_CLICKED: 'Upload Another Video Clicked',
  CLIP_PREVIEW_PLAYED: 'Clip Preview Played',
  PRICING_FAQ_ITEM_OPENED: 'FAQ clicked',
  UPLOAD_BUTTON: 'Upload_Button',
  GENERATE_SHORTS_BUTTON: 'Generate_Shorts_Button',
  SIGNUP_BUTTON: 'Signup_Button',
  DOWNLOAD: 'Download',
  SHARE_VIDEO: 'Share Video',
  BACK: 'Back',
  WHATSAPP_SUPPORT_FAB: 'WhatsApp Support FAB',
  WHATSAPP_SUPPORT_SEND: 'WhatsApp Support Send',
  WHATSAPP_SUPPORT_UPGRADE: 'WhatsApp Support Upgrade',
  STREAK_REMINDERS_ENABLED: 'Streak Reminders Enabled',
  STREAK_REMINDERS_DENIED: 'Streak Reminders Denied',
  PUSH_NOTIFICATION_OPENED: 'Push Notification Opened',
  STREAK_REMINDERS_CTA: 'Streak Reminders CTA',
  STREAK_REMIND_ME_CLICKED: 'Streak Remind Me Clicked',
  STREAK_OVERLAY_SHOWN: 'Streak Overlay Shown',
  ONE_TAP_PUBLISH_CLICKED: '1-Tap Publish Clicked',
  PAST_PROJECT_CLICKED: 'Past Project Clicked',
  PUBLISH_TO_SOCIAL_CLICKED: 'Publish to Social Clicked',
  CONNECT_ACCOUNT_CLICKED: 'Connect Account Clicked',
  ONE_TAP_SCHEDULE_CLICKED: '1-Tap Schedule Clicked',
  SCHEDULE_A_CLIP_CLICKED: 'Schedule a Clip Clicked',
  SCHEDULE_CLIP_DIALOG_SUBMITTED: 'Schedule Clip Dialog Submitted',
  ONE_TAP_SCHEDULE_PREFERENCES_SAVED: '1-Tap Schedule Preferences Saved',
  AI_SOCIAL_ANALYSIS_CONNECT_CLICKED: 'Connect Instagram Clicked',
  AI_SOCIAL_ANALYSIS_SUBMITTED: 'Analyse My Handles Clicked',
};
